let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dH4eU")).then(() => parcelRequire('8EREH'));